import React from 'react'
import './styles.scss'

interface Props {
  errors: string[]
}

const ErrorComponent = ({ errors }: Props) => {
  return (
    <div className='error-component-wrapper'>
      {errors.length > 0 &&
        errors.map((error, i) => (
          <p key={`${error}-${i}`} className='error'>
            {error}
          </p>
        ))}
    </div>
  )
}

export default ErrorComponent
